const PanelContent = {
  baseStyle: {
    ms: 'auto',
    me: 'auto',
    ps: '0px',
    pe: '0px',
  },
};

export const PanelContentComponent = {
  components: {
    PanelContent,
  },
};
